module.exports = __webpack_public_path__ + "media/images/logo-4be8060c9f8a9246440b18bc4d89abe4.svg";